<script>
import {mapActions, mapState} from "pinia";
import {authStore} from "@/store/authStore";
import {managerStore} from "@/store/managerStore";
import ManagerCompanyInfoForm from "@/views/manager/ManagerCompanyInfoForm.vue";

export default {
  name: "ManagerCompanyInfoSection",
  components: {
    ManagerCompanyInfoForm
  },
  data() {
    return {
      companyInfoModalState: false
    }
  },
  computed: {
    ...mapState(authStore, [
      'managerProfileInfo',
    ]),
    ...mapState(managerStore, [
      'managerCompanyInfo',
      'managerHasCompanyInfo'
    ]),
  },
  methods: {
    ...mapActions(managerStore, [
      'getManagerProfileInfo',
      'openCompanyInfoModal'
    ]),
    showCompanyInfoModal() {
      this.openCompanyInfoModal({
        editMode: true
      });
    }
  }
}
</script>

<template>
  <div class="company-info-section">
    <div class="d-flex justify-content-between">
      <span class="company-info-section__title">{{$t('companyInformation.title')}}</span>
      <button type="button" class="go-to-ka-btn mr-10" @click="showCompanyInfoModal()">
        <template v-if="managerHasCompanyInfo">
          {{$t('companyInformation.editCompanyInformation')}}
        </template>
        <template v-else>
          {{$t('companyInformation.addCompanyInformation')}}
        </template>
      </button>
    </div>
    <manager-company-info-form :edit-mode="false"/>
  </div>
</template>